import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { AppointmentSignatureDoc } from '@bb/domain/dist/schemas';
import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';

export type GetExternalAppointmentSignatureOptions = {
  appointmentId: string;
  dashboardInfo: { dashboardId: string; retsId: string };
};

export type GetExternalAppointmentSignatureResponse =
  BuildJsonType<AppointmentSignatureDoc>;

const getExternalAppointmentSignature = async ({
  appointmentId,
  dashboardInfo,
}: GetExternalAppointmentSignatureOptions) => {
  const config: AxiosRequestConfig = {
    url: `/external/covid19/appointment/${appointmentId}/settings`,
    method: 'get',
    params: dashboardInfo,
  };

  const { data } =
    await axios.request<GetExternalAppointmentSignatureResponse>(config);

  return data;
};

export default getExternalAppointmentSignature;
